import React, { Component, useEffect, useState } from 'react';
import { Progress } from 'antd';
import { createSwatch, getImageUrlSwatch, putImageToS3 } from '../../apis/swatchApi';
import useLogout from '../../hooks/useLogout';

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16,
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box',
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
};

const img = {
    width: '200px',
    height: '300px',
};
export default function SingleFileUpload({ file, companyCode, company }) {
    const [progress, setProgress] = useState(0);
    const [isComplete, setIsComplete] = useState(false);
    const { logout } = useLogout();
    useEffect(() => {
        getImageUrlSwatch(companyCode, file.name)
            .then(res => {
                const { url, key } = res;
                putImageToS3(url, file, setProgress)
                    .then(res => {
                        createSwatch(company, file.name, key)
                            .then(res => {
                                setIsComplete(true);
                                setProgress(100);
                            })
                            .catch(err => {
                                console.log(err);
                            });
                    })
                    .catch(err => {
                        console.log(err);
                    });
            })
            .catch(err => {
                console.log(err);
                if (err?.response?.status === 401) logout();
            });
    }, []);

    return (
        <div>
            <div style={thumb} key={file.name}>
                <div style={thumbInner}>
                    <img
                        src={file.preview}
                        style={img}
                        // Revoke data uri after image is loaded
                        onLoad={() => {
                            URL.revokeObjectURL(file.preview);
                        }}
                    />
                    <p>{file.name}</p>
                </div>
            </div>
            <p>{file.name}</p>
            <Progress percent={progress} />
        </div>
    );
}
